import { createComponent } from '../lib';
import { VmYoutube, VmEmbed } from '@vime/core';
import { define } from '../lib';
define('vm-youtube', VmYoutube);
define('vm-embed', VmEmbed);
;
export default createComponent('vm-youtube', new Set(['cookies', 'videoId', 'showFullscreenControl', 'poster', 'language', 'autoplay', 'controls', 'logger', 'loop', 'muted', 'playsinline']));
